import { Component, ViewChild, inject, ElementRef, NgZone, ChangeDetectorRef } from "@angular/core";
import { GlobalService } from "src/app/Services/global.service";
import { Router, ActivatedRoute } from "@angular/router";
import { FormGroup,FormControl,Validators } from '@angular/forms';
import { ImageCroppedEvent, LoadedImage ,Dimensions,ImageTransform} from "ngx-image-cropper";
import { DomSanitizer } from "@angular/platform-browser";
import { HttpEventType,HttpClient, HttpHeaders,HttpRequest, } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import moment from 'moment-timezone';
import { getLocalJSON } from '../../_helpers/storage.util';
declare var $: any;

@Component({
  selector: 'app-createsinglevideopost',
  templateUrl: './createsinglevideopost.component.html',
  styleUrls: ['./createsinglevideopost.component.scss']
})
export class CreatesinglevideopostComponent {

  public loading: boolean = false;
  public imgError: boolean = false;
  public submitted: boolean = false;
  public videoUrl: any = "";
  public filesName: any = [];
  public filesNamestring: any = "";
  public videoFileContent: any = [];
  public responseData:any='';
  public videoUploadPercentage: any = "0";
  public videoUploadStart: boolean = false;
  public videoDuration:any='';
  public freechcek:boolean=false;
  public videoUploadedCHeck:boolean=false;
  baseUrl =  `${environment.apiEndPoint}`;

  selectedVidoe: any = "";
  public selectedFile: any = "";
  public pendingVideoFile: any = "";
  public userUpdatedImage: any;
  public imagePath: any;
  imgURL: any = "";
  public message: any;
  public videoName: any = "";
  public videoSize: any = "";
  public datadetail: any = {};
  imageChangedEvent: any = "";
  croppedImage: any = "";
  croppedImage1: any = "";
  canvasRotation = 0;
  rotation?: number;
  translateH = 0;
  translateV = 0;
  scale = 1;
  aspectRatio = 4 / 3;
  showCropper = false;
  containWithinAspectRatio = false;
  transform: ImageTransform = {
    translateUnit: 'px'
  };
  imageURL?: string;
  allowMoveImage = false;
  hidden = false;
  public filestart: any = 0;
  public fileend: any = "";
  public currentUrl:any=this.router.url;
  public standardview:boolean = true;
  public nutritionView:boolean = false;
  public post_type:any=1;
  public post_ctype:any=1;
  public dimendionList:any=[];
  public freeshowhide:any=false;

  postData :any = new FormGroup({
    albumName:new FormControl('',Validators.compose([
      Validators.required])),
    dimention :new FormControl('')
  })
  
   get f() { return this.postData.controls; }

  constructor(
    private sanitizer: DomSanitizer,
    private el: ElementRef,
    public router: Router,
    public service: GlobalService,
    private http: HttpClient,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef
  ) {  
   var ss:any = getLocalJSON('grw_materData');
   this.dimendionList = ss.dimension;
   var mm:any = localStorage.getItem('grw_freevideo');
   if(mm === '0' || mm === 0){
     this.freeshowhide = true;
     this.freechcek = false;
   }
    if(this.currentUrl =='/update-post' || this.currentUrl == '/create-posts'){
      this.datadetail = getLocalJSON("grw_upload_Data");
      this.postData.controls["albumName"].setValue(this.datadetail.name || '');
      if(this.datadetail.post_type==1 || this.datadetail.post_type==3){ 
        if (this.datadetail.dimensions && Array.isArray(this.datadetail.dimensions) && this.datadetail.dimensions.length > 0) {
          this.datadetail.dimension_id = this.datadetail.dimensions[0]._id;
        } else if (this.datadetail.dimension) {
          this.datadetail.dimension_id = this.datadetail.dimension;
        }
        this.freechcek = Boolean(this.datadetail.is_content_free); 
        if(this.datadetail.content){
          this.videoName = this.datadetail.content;
        }
        this.videoUrl = (this.datadetail.bunny_status === 'finished' && this.datadetail.bunny_playback_url) ? this.datadetail.bunny_playback_url : (this.datadetail.content || '');
        this.imgURL = this.datadetail.thumbnail || '';
      } else {
        this.imgURL = this.datadetail.thumbnail || '';
      }
     
      this.datadetail.post_id = this.datadetail._id || this.datadetail.record_id;
      this.post_type = this.datadetail.post_type;
      this.post_ctype = this.datadetail.post_category;
      this.responseData = 1;
      this.cdr.detectChanges();
      if(this.datadetail.post_category==1){
        setTimeout(() => {
        $('#pills-standard-tab').trigger('click');
        setTimeout(() => {  $('#pills-standard-tab').addClass(' active'); }, 100);
        if(this.datadetail.post_type==1){
          setTimeout(() => {  $('#pills-video-tab').addClass(' active');  $('#pills-image-tab').removeClass(' active'); $('#pills-document-tab').removeClass('active');},  300);
        } else if(this.datadetail.post_type==2){
          setTimeout(() => { $('#pills-video-tab').removeClass(' active');  $('#pills-image-tab').addClass(' active'); $('#pills-document-tab').removeClass('active'); }, 300);
        } else {
          setTimeout(() => { $('#pills-video-tab').removeClass(' active'); $('#pills-image-tab').removeClass(' active'); $('#pills-document-tab').addClass('active'); }, 300);
        }
      }, 200);
      } else { 
        setTimeout(() => {
          $('#pills-nutrition-tab').trigger('click');
          setTimeout(() => {  $('#pills-nutrition-tab').addClass(' active'); }, 100);  
          if(this.datadetail.post_type==1){
            setTimeout(() => {  $('#pillss-video-tab').addClass(' active'); $('#pillss-image-tab').removeClass(' active'); $('#pillss-document-tab').removeClass('active');  }, 200);
          } else if(this.datadetail.post_type==2){
            setTimeout(() => { $('#pillss-video-tab').removeClass(' active');  $('#pillss-image-tab').addClass(' active');  $('#pillss-document-tab').removeClass('active');}, 200);
          } else {
            setTimeout(() => { $('#pillss-video-tab').removeClass(' active');  $('#pillss-image-tab').removeClass(' active'); $('#pillss-document-tab').addClass('active'); }, 200);
          }
        }, 200);      
      }
    }
  }

  ngOnInit(): void {}

  generateVideoThumbnail(file: File): Promise<string> {
    return new Promise((resolve) => {
      if (!file || !file.type.startsWith('video/')) {
        resolve('');
        return;
      }
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.src = URL.createObjectURL(file);
      video.muted = true;
      video.playsInline = true;

      let settled = false;
      let seeking = false;
      const finish = (value: string) => {
        if (settled) return;
        settled = true;
        clearTimeout(safetyTimer);
        URL.revokeObjectURL(video.src);
        resolve(value);
      };

      // Safety net: some browsers (Safari in particular, with preload="metadata")
      // never fire loadeddata/onseeked for certain files, which would otherwise
      // hang this promise forever and block the whole upload flow after it.
      const safetyTimer = setTimeout(() => finish(''), 4000);

      const trySeek = () => {
        if (seeking || settled) return;
        seeking = true;
        video.currentTime = Math.min(1, video.duration / 2 || 0);
      };

      video.onloadeddata = trySeek;
      video.onloadedmetadata = trySeek;

      video.onseeked = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = video.videoWidth || 640;
          canvas.height = video.videoHeight || 360;
          const ctx = canvas.getContext('2d');
          if (ctx) {
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            finish(canvas.toDataURL('image/png'));
            return;
          }
        } catch (e) {}
        finish('');
      };

      video.onerror = () => finish('');
    });
  }

  getUploadFileDetail(event: any, type: any) {
    var myVideos:any = [];
    var select_image: any='',count=0,
      self = this;
    select_image = event[0];
    var mimeType = event[0].type;
    if (type == 4) {
      if (mimeType.match(/video\/*/) == null) {
        this.service.warningAlert("Only Videos are supported.");
        return;
      }
      this.datadetail.videoUploadingStep =2;
      this.videoName = select_image.name;
      this.videoSize = (select_image.size / 1024 / 1024).toFixed(2);
      let file = event[0];
      var reader = new FileReader();
      reader.readAsDataURL(event[0]);
      reader.onload = (e:any) => {
        var videoElement:any = document.createElement('video');
        videoElement.src = e.target.result;
          var timer = setInterval(function () {
            if (videoElement.readyState === 4){
              var ss:any= videoElement.duration/60;
              var mm:any= videoElement.duration%60 ;         
              self.videoDuration =parseInt(ss) +'.'+parseInt(mm) ;
              clearInterval(timer);
              if((videoElement.duration < 10 || videoElement.duration > 300) && self.freechcek ==true ){
                count=1;
              }
              if(videoElement.duration < 10 && self.freechcek ==false){
                count=1;
              }
              let blobURL = URL.createObjectURL(file);
              self.videoUrl = blobURL;        
              self.selectedVidoe = select_image;
              if(count==1){
                self.videoName ='';
                self.videoUrl = '';
                self.service.dangerAlert('Please Choose Another Video');
              } else {
                try {
                  videoElement.currentTime = 1;
                  videoElement.onseeked = () => {
                    if (!self.selectedFile && (!self.imgURL || self.imgURL.includes('1704990093505.png'))) {
                      const canvas = document.createElement('canvas');
                      canvas.width = videoElement.videoWidth || 640;
                      canvas.height = videoElement.videoHeight || 360;
                      const ctx = canvas.getContext('2d');
                      if (ctx) {
                        ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
                        const dataUrl = canvas.toDataURL('image/png');
                        self.imgURL = dataUrl;
                        self.croppedImage = dataUrl;
                        self.croppedImage1 = dataUrl;
                        self.cdr.detectChanges();
                      }
                    }
                  };
                } catch (err) {}
              }

            }
          }, 200)
        };		
 
      //  return;  
     
    } else if (type == 3) {
      if (mimeType.match(/application\/*/) == null) {
        this.service.warningAlert("Only Application are supported.");
        return;
      }
      this.videoName = select_image.name;
      this.videoSize = (select_image.size / 1024 / 1024).toFixed(2);
      const file: File = event[0];
      if (file) {
        this.selectedVidoe = file;
      }
    } else {
      this.selectedFile = select_image;
      if (mimeType.match(/image\/*/) == null) {
        this.service.warningAlert("Only images are supported.");
        return;
      }
      var reader = new FileReader();
      this.imagePath = event;
      reader.readAsDataURL(event[0]);
      reader.onload = (_event) => {
        this.imgURL = reader.result;
      };
    }
  }

  changeImage(file: any) {
    var mm = "#" + file;
    $(mm).trigger("click");
  }

  changeImage1(event: any, type: any) {
    if(type==4){
      this.onFileSelected(event);
    } else {
      this.imageChangedEvent = event;
      this.getUploadFileDetail(event.target.files, type);
    }
  }

  onDragOver(event: any) {
    event.preventDefault();
  }

  // From drag and drop
  onDropSuccess(event: any, type: any) {
    this.imageChangedEvent = event;
    event.preventDefault();
    this.getUploadFileDetail(event.dataTransfer.files, type); // notice the "dataTransfer" used instead of "target"
  }

  VideoUploadstart(select_image: any) {
    var url = "/start-video-upload";
    var detail: any = {
      post_id: this.datadetail.post_id,
    };
    this.videoUploadPercentage = "0";
    this.videoUploadStart = true;
    this.service.PostApis(detail, url).subscribe(async (response: any) => {
      if (response.success == 1) {
        var self = this,
          counter: any = 1;
        this.loading = true;

        const fileParts = this.service.get_parts_count(select_image)
        // this.VideoUpload(select_image, fileParts);
        self.fileend = 1024 * 1024 * 6;
        const fileMaster = select_image;

        const fileExtension = (fileMaster.name).split('.').pop();
        const chunkSize = 1024 * 1024 * 6; // Please don't change this. If you change please update the backend team
        const totalChunk = Math.ceil(fileMaster.size / chunkSize);
        const processChunkCounter = 100 / totalChunk;

        for (let chunkNumber = 0; chunkNumber < totalChunk; chunkNumber++) {
          const start = chunkNumber * chunkSize;
          const end = Math.min(start + chunkSize, fileMaster.size);
          const chunk = fileMaster.slice(start, end);
          const resp = await this.uploadVideoChunk(chunk, totalChunk, chunkNumber);
          if ((chunkNumber + 1) === totalChunk) {
            setTimeout(() => {
              this.VideoUploadFinish(totalChunk, fileExtension);
            }, 20000);
          }
          this.uploadVideoFilePercentage(processChunkCounter);
        }

      } else {
        this.service.dangerAlert(response.message);
        this.loading = false;
      }
    });
  }

  uploadVideoChunk = (blobConversion: any, totalChunks: any, counter: any) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const response = this.VideoUpload(blobConversion, totalChunks, counter);
        resolve(`Response for ${response}`);
      }, 6000); // delay of 4 second
    });
  }

  uploadVideoFilePercentage = (percentage: number) => {
    let progressAmount: number = +this.videoUploadPercentage + percentage;
    progressAmount = (progressAmount > 100) ? 100 : progressAmount;
    this.videoUploadPercentage = progressAmount.toFixed(2);
  };

  private applyUploadResponse(data: any): void {
    if (!data) return;
    this.responseData = data;
    if (data.thumbnail || data.thumb) {
      const thumbnail = data.thumbnail || data.thumb;
      this.imgURL = thumbnail;
      localStorage.setItem('grw_upload_images', thumbnail);
    }
    if (data.bunny_status === 'finished' && data.bunny_playback_url) {
      this.videoUrl = data.bunny_playback_url;
    } else if (data.content) {
      this.videoUrl = data.content;
    }
    if (!this.datadetail || Array.isArray(this.datadetail)) {
      this.datadetail = {};
    }
    this.datadetail.videoUploadingComplete = data.videoUploadingComplete ?? false;
    this.datadetail.videoUploadingStep = data.videoUploadingStep ?? 2;
    this.datadetail.bunny_status = data.bunny_status || 'processing';
    this.datadetail.bunny_error = data.bunny_error || '';
    this.datadetail.bunny_playback_url = data.bunny_playback_url || '';
    this.videoUploadedCHeck = true;
  }

  VideoUpload(data: any, fileCount: number, counter: number): any {
    var url = "/upload-video-post";
    let formdata = new FormData();
    formdata.append("post_id", this.datadetail.post_id);
    formdata.append("total_chunk", fileCount.toString());
    formdata.append("current_chunk", counter.toString());
    formdata.append("video_file", data);
    this.service
      .PostApiFormData(formdata, url)
      .subscribe((response: any) => {
        if (response.success == 1) {
          this.videoFileContent.push({
            file: response.data.file,
          });
          if (this.filesNamestring != "") {
            this.filesNamestring =
              this.filesNamestring + "," + response.data.file;
          } else {
            this.filesNamestring = response.data.file;
          }
          this.filesName.push(response.data.file);
          return true;
        } else {
          this.service.dangerAlert(response.message);
          this.loading = false;
          return false;
        }
      });
  }

  VideoUploadFinish(count: number, uploadFileName: string = '') {
    const self = this;
    this.loading = true;
    let fileName = this.videoFileContent[0];
    fileName = fileName.file;
    let url = "/complete-video-post";
    let detail: any = {
      post_id: this.datadetail.post_id,
      video_file: uploadFileName,
      // video_per_file_size: 6 * 1024 * 1024,
      video_chunk_count: count,
      duration: self.videoDuration
    };
    this.service.PostApis(detail, url).subscribe((response: any) => {
      if (response.success == 1) {
        this.service.successAlert(response.message);
        this.applyUploadResponse(response.data);
        setTimeout(()=>{
          this.loading = false;
        },300)
      } else {
        this.service.dangerAlert(response.message);
        this.loading = false;
      }
    });
  }


  VideoUploadnew(uploadFileName: any) {
    const self = this;
    this.loading = true;
    let url = "/upload-post-video";
    let formdata:any=new FormData();
      formdata.append('post_id', this.datadetail.post_id);
      formdata.append('video_file', uploadFileName);
      formdata.append('duration', self.videoDuration);
    this.service.PostApiFormData(formdata, url).subscribe((response: any) => {
      if (response.success == 1) {
        self.applyUploadResponse(response.data);
        setTimeout(()=>{
          this.service.successAlert(response.message);
          this.loading = false;
        },300)
      } else {
        this.service.dangerAlert(response.message);
        this.loading = false;
      }
    });
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }


  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl || event.base64 || '');
    console.log(event);
  }

  imageCropped1(event: any) {
    var reader = new FileReader();
    reader.readAsDataURL(event.blob);
    const self = this;
    reader.onloadend = function () {
      var base64data = reader.result;
      self.croppedImage1 = base64data;
    }
    console.log(self.croppedImage1);
  }

  imageLoaded() {
    this.showCropper = true;
    console.log('Image loaded');
  }

  cropperReady(sourceImageDimensions: Dimensions) {
    console.log('Cropper ready', sourceImageDimensions);
    this.loading = false;
  }

  loadImageFailed() {
    console.error('Load image failed');
  }

  getData(type:any){
    if(type==1){       
      this.post_type=1;    
    } else if(type==2){      
      this.post_type=2;      
    } else if(type==3){      
      this.post_type=3; 
    } else if(type==4){      
      this.standardview = true;
      this.nutritionView = false;      
      this.post_ctype=1;
    } else {
      this.standardview = false;
      this.nutritionView = true;      
      this.post_ctype=2;
    }
  }


   Onsubmit(){
    const bypassProfileCheck = environment.bypassProfileCheck ?? false;
    const loginDetail = getLocalJSON('grw_login');
    if (!this.freechcek && !bypassProfileCheck && !loginDetail.stripe_account_verify) {
      this.service.dangerAlert("Please verify your Stripe account to upload paid content");
      this.loading = false;
      return;
    }

    this.loading=true;
    this.submitted = true;   
    let userdetail :any={};   
      let formdata:any=new FormData();
        userdetail = this.postData;
        formdata.append('name', userdetail.value.albumName || '');
        formdata.append('section_id', '1');
        if (this.currentUrl == '/update-post') {
          formdata.append('post_id', String(this.datadetail.post_id || ''));
          formdata.append('post_type', String(this.datadetail.post_type || ''));
          formdata.append('post_category', String(this.datadetail.post_category || ''));
        } else {
          formdata.append('post_type', String(this.post_type));
          formdata.append('post_category', String(this.post_ctype));
        }
        if (this.post_type == 2 || this.datadetail.post_type == 2) {
          if (this.croppedImage == "") {
            this.service.dangerAlert("Mandatory fields need to be completed");
            this.loading = false;
            return;
          } else {
            if (this.croppedImage1 != "") {
              const fileObject = this.service.dataURLtoFile(
                this.croppedImage1,
                "post.png"
              );
              formdata.append("content", fileObject);
            }
          }
        } else {
          formdata.append('dimension', String(this.dimendionList[0]?._id || ''));
          formdata.append('is_content_free', String(this.freechcek));

          if (this.croppedImage1 != "") {
            const fileObject = this.service.dataURLtoFile(
              this.croppedImage1,
              "post.png"
            );
            formdata.append("content", fileObject);
          }
        }

        const fileToUpload = this.pendingVideoFile || this.selectedFile || this.selectedVidoe;
        if (fileToUpload && this.post_type != 2 && this.datadetail.post_type != 2) {
          formdata.append('video_file', fileToUpload, fileToUpload.name);
          formdata.append('duration', String(this.videoDuration || ''));
        }

        if(this.videoUrl == '' && this.datadetail.post_type!=2 && this.post_type!=2){
          this.service.dangerAlert('Mandatory fields need to be completed');
          this.loading=false;
          return
        } 

      if(userdetail.valid){           
        const hasVideoFile = !!fileToUpload && this.post_type != 2 && this.datadetail.post_type != 2;
        if (hasVideoFile) {
          this.videoUploadStart = true;
          this.videoUploadPercentage = 0;
          this.cdr.detectChanges();

          // ── STEP 1: Get pre-signed S3 URL from backend (fast, <100ms) ──────────
          this.service.PostApis({
            filename: fileToUpload.name,
            contentType: fileToUpload.type || 'video/mp4',
          }, '/pre-sign-video-upload').subscribe({
            next: (preSignResp: any) => {
              if (preSignResp?.success != 1) {
                this.service.dangerAlert(preSignResp?.message || 'Could not get upload URL');
                this.loading = false;
                this.videoUploadStart = false;
                this.cdr.detectChanges();
                return;
              }

              const { uploadUrl, s3Url } = preSignResp.data;

              // ── STEP 2: Upload file DIRECTLY to S3 with real progress ─
              const s3Req = new HttpRequest('PUT', uploadUrl, fileToUpload, {
                headers: new HttpHeaders({ 'Content-Type': fileToUpload.type || 'video/mp4' }),
                reportProgress: true,
              });

              this.http.request(s3Req).subscribe({
                next: (event: any) => {
                  if (event.type === HttpEventType.UploadProgress && event.total) {
                    this.videoUploadPercentage = Math.round((90 * event.loaded) / event.total);
                    this.cdr.detectChanges();
                  } else if (event.type === HttpEventType.Response) {
                    this.videoUploadPercentage = 95;
                    this.cdr.detectChanges();

                    // ── STEP 3: POST metadata to backend (instant, no video file) ──
                    (async () => {
                      if (!this.croppedImage1 || this.croppedImage1 === '') {
                        this.croppedImage1 = await this.generateVideoThumbnail(fileToUpload);
                      }
                      const metaFormdata = new FormData();
                      metaFormdata.append('name', userdetail.value.albumName || '');
                      metaFormdata.append('section_id', '1');
                      metaFormdata.append('post_type', String(this.post_type));
                      metaFormdata.append('post_category', String(this.post_ctype));
                      metaFormdata.append('dimension', String(this.dimendionList[0]?._id || ''));
                      metaFormdata.append('is_content_free', String(this.freechcek));
                      metaFormdata.append('duration', String(this.videoDuration || ''));
                      metaFormdata.append('video_s3_url', s3Url);
                      metaFormdata.append('video_original_name', fileToUpload.name);
                      if (this.croppedImage1 != '') {
                        const fileObject = this.service.dataURLtoFile(this.croppedImage1, 'post.png');
                        metaFormdata.append('content', fileObject);
                      }

                      this.service.PostApiFormData(metaFormdata, '/create-single-post').subscribe({
                        next: (response: any) => {
                          console.log('[create-single-post] response:', response);
                          if (response?.success == 1) {
                            if (!this.datadetail || Array.isArray(this.datadetail)) {
                              this.datadetail = {};
                            }
                            this.datadetail.post_id = response.data.record_id;
                            this.datadetail.name = response.data.name || this.postData.value.albumName || '';
                            this.datadetail.post_category = response.data.post_category;
                            this.datadetail.post_type = response.data.post_type;
                            const storeData = { ...response.data, _id: response.data.record_id, name: response.data.name || this.postData.value.albumName || '' };
                            localStorage.setItem('grw_upload_Data', JSON.stringify(storeData));
                            this.applyUploadResponse(response.data);
                            this.videoUploadPercentage = 100;
                            this.videoUploadStart = false;
                            this.loading = false;
                            this.cdr.detectChanges();
                          } else {
                            this.service.dangerAlert(response?.message || 'Upload failed');
                            this.loading = false;
                            this.videoUploadStart = false;
                            this.cdr.detectChanges();
                          }
                        },
                        error: (err: any) => {
                          console.error('[create-single-post] error:', err);
                          this.service.dangerAlert('Network error while saving post');
                          this.loading = false;
                          this.videoUploadStart = false;
                          this.cdr.detectChanges();
                        }
                      });
                    })();
                  }
                },
                error: (err: any) => {
                  console.error('[S3 upload] error:', err);
                  this.service.dangerAlert('Video upload to storage failed');
                  this.loading = false;
                  this.videoUploadStart = false;
                  this.cdr.detectChanges();
                }
              });
            },
            error: (err: any) => {
              console.error('[pre-sign] error:', err);
              this.service.dangerAlert('Failed to initiate upload');
              this.loading = false;
              this.videoUploadStart = false;
              this.cdr.detectChanges();
            }
          });

        } else {
          this.service.PostApiFormData(formdata, '/create-single-post').subscribe((response: any) => {
            if(response.success==1){
              if (!this.datadetail || Array.isArray(this.datadetail)) {
                this.datadetail = {};
              }
              this.datadetail.post_id=response.data.record_id;
              this.datadetail.name = response.data.name || '';
              this.datadetail.post_category=response.data.post_category;
              this.datadetail.post_type =response.data.post_type;
              const storeData = { ...response.data, _id: response.data.record_id, name: response.data.name || this.postData.value.albumName || '' };
              localStorage.setItem('grw_upload_Data',JSON.stringify(storeData)) 
              this.applyUploadResponse(response.data);
              this.videoUploadStart = true;
              this.videoUploadPercentage = 100;
              this.loading=false;
              this.cdr.detectChanges();
            } else {
              this.service.dangerAlert(response.message);
              this.loading=false;
              this.cdr.detectChanges();
            }
            return response.data?.file;
          });
        }
      } else{ 
        const invalidControls: string[] = [];
        Object.keys(userdetail.controls).forEach((controlName) => {
          const control = userdetail.get(controlName);
          if (control && control.invalid) {
            invalidControls.push(controlName);
          }
        });
        if(invalidControls.length >1){
          this.service.dangerAlert('Please complete mandatory sections.');
        } else {
          
          this.service.dangerAlert('Title Name  is required.');
        }
        this.loading = false
        this.cdr.detectChanges();
        userdetail.markAllAsTouched();
        this.scrollToFirstInvalidControl();  
      }
  }  
   

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      "form .ng-invalid"
    );
    // firstInvalidControl.focus(); //without smooth behavior
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: "smooth"
    });
  }
  
  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  redirect(){
    if(this.croppedImage != ""){
      let formdata:any=new FormData();
      formdata.append('name',this.postData.value.albumName);
      formdata.append('section_id',1);
      formdata.append('post_id',this.datadetail.post_id);
      formdata.append('post_type',this.datadetail.post_type);
      formdata.append('post_category',this.datadetail.post_category);
      if (this.croppedImage1 != "") {
        const fileObject = this.service.dataURLtoFile(
          this.croppedImage1,
          "post.png"
        );
        formdata.append("content", fileObject);
      }
      this.service.PostApiFormData(formdata, '/create-single-post').subscribe((response: any) => {
        if(response.success==1){
          localStorage.removeItem('grw_upload_images');
          this.applyUploadResponse(response.data);
          if(this.currentUrl =='/create-post'){
            this.router.navigate(['/create-posts']);
          } else {
            this.router.navigate(['/singles']);
          }
        } else {
          this.service.dangerAlert(response.message);
        }
      });
    } else {
      if(this.currentUrl =='/create-post'){
        this.router.navigate(['/create-posts']);
      } else {
        this.router.navigate(['/singles']);
      }
    }
 
  }

  getCheckType(event:any){
    this.freechcek = event.target.checked;
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (file) {
      this.videoName =file.name;
      let blobURL = URL.createObjectURL(file);
      this.videoUrl= blobURL;   
      this.selectedVidoe = file;
      this.videoUploadPercentage = 0; // Reset progress
      this.message = ''; // Reset message
      this.videoDuration = null;
      this.getFileDuration(file);
    }
  }

  uploadFile(): void {
    if (this.selectedFile) {
      const formData:any = new FormData();
      formData.append('video_file', this.selectedFile, this.selectedFile.name);
      formData.append('post_id', localStorage.getItem('grw_content_id'));
      formData.append('duration', 5);
      const uploadReq = new HttpRequest(
        'POST',
        this.baseUrl+'/upload-post-video',
        formData,
        {
          headers: new HttpHeaders(),
          reportProgress: true,
        }
      );

      this.http.request(uploadReq).subscribe(
        (event: any) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              if (event.total) {
                this.videoUploadPercentage = Math.round((100 * event.loaded) / event.total);
              }
              break;
            case HttpEventType.Response:
              if (event.body?.success == 1) {
                this.applyUploadResponse(event.body.data);
                this.message = 'File uploaded successfully!';
              } else {
                this.message = event.body?.message || 'Error uploading file!';
              }
              break;
            default:
              break;
          }
        },
        (error:any) => {
          this.message = 'Error uploading file!';
          console.error(error);
        }
      );
    }
  }

  VideoUploadnew11(uploadFileName: any) {
    const self = this;
    this.loading = true;
    let formdata:any=new FormData();
      formdata.append('post_id', this.datadetail.post_id);
      formdata.append('video_file', uploadFileName,uploadFileName.name);
      formdata.append('duration', self.videoDuration);
      var data:any = "";
      if (localStorage.getItem('grw_token')) {
        data ='Bearer '+  localStorage.getItem('grw_token');
      }
      this.videoUploadStart = true;
    const uploadReq = new HttpRequest(
      'POST',
      this.baseUrl+'/upload-post-video',
      formdata,
      {
        headers: new HttpHeaders({
          "X-Authorization": data,
          "device-type": "Browser",
          "device-token": "8749",
          "Version": "1.0.0",
          "time-zone":moment.tz.guess(),
          "Accept-Language":'en',
        }),
        reportProgress: true,
      }
    );

    this.http.request(uploadReq).subscribe(
      (event: any) => {
        
        switch (event.type) {
          case HttpEventType.UploadProgress:
            if (event.total) {
              this.videoUploadPercentage = Math.round((100 * event.loaded) / event.total);
            }
            break;
          case HttpEventType.Response:
            if (event.body.success == 1) {
              self.applyUploadResponse(event.body.data);
              setTimeout(()=>{
                this.service.successAlert(event.body.message);
                this.loading = false;
              },300)
            } else {
              this.service.dangerAlert(event.body.message);
              this.loading = false;
            }
            // this.message = 'File uploaded successfully!';
            break;
          default:
            break;
        }
      },
      (error:any) => {
        console.error(error);
      }
    );
  }

  isAudioOrVideoFile(file: File): boolean {
    // Check if the file type is audio or video
    return file.type.startsWith('audio') || file.type.startsWith('video');
  }

  createMediaElement(fileType: string): HTMLAudioElement | HTMLVideoElement {
    if (fileType.startsWith('audio')) {
      return new Audio();
    } else if (fileType.startsWith('video')) {
      return document.createElement('video');
    }
    return null as any; // Return null if not audio/video
  }

  getFileDuration(file: File): void {
    var self=this,count=0;
    const fileReader = new FileReader();
    const url = URL.createObjectURL(file);

    const mediaElement = this.isAudioOrVideoFile(file)
      ? this.createMediaElement(file.type)
      : null;

    if (mediaElement) {
      mediaElement.src = url;
      mediaElement.onloadedmetadata = () => {
        this.videoDuration = mediaElement.duration; // Set file duration
        if((this.videoDuration < 10 || this.videoDuration > 300) && self.freechcek ==true ){
          count=1;
        }
        if(this.videoDuration < 10 && self.freechcek ==false){
          count=1;
        }
        let blobURL = URL.createObjectURL(file);
        self.videoUrl = blobURL;        
        if(count==1){
          self.videoName ='';
          self.videoUrl = '';
          self.service.dangerAlert('Please Choose Another Video');
        } 
        console.log('File Duration:', this.videoDuration);
      };
    }
  }
}



